"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var subtractMonths = function subtractMonths(date, months) {
  return (0, _dayjs["default"])(date).subtract(months, 'month').toISOString();
};

var _default = subtractMonths;
exports["default"] = _default;